import { isAriaOrDataProp } from './isAriaOrDataProp';

/**
 * Returns a subset of generally spreadable props. "Generally spreadable" props include props that
 * start with `data-` or `aria-`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- best way to represent "any object" in this case; see https://github.com/microsoft/TypeScript/issues/15300
export const pickAriaAndDataProps = (props: Record<string, any>) =>
  // The return type has no specific properties because aria and data props are
  // always implicitly allowed as props and are they not expected to be defined
  // on a component's props type.
  Object.fromEntries(Object.entries(props).filter(([key]) => isAriaOrDataProp(key))) as Record<
    string,
    unknown
  >;
